import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { VMPSiteMap } from '@src/types/VMPSiteMap'

interface Options {
  vmpId: number,
  siteMapId: number,
  serialId: number,
  siteMap: VMPSiteMap,
}

export const apiVMPUpdateSiteMap = (options: Options) => {
  const { vmpId, siteMapId, serialId, siteMap } = options
  const data = {
    ...siteMap,
  }
  const axOptions = {
    method: 'PUT',
    url: `${BASE_API_URL}/v2/vmp/${vmpId}/sites/${siteMapId}`,
    data,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}